import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ArticlesComponent } from './pages/articles/articles.component';
import { CreateArticleComponent } from './pages/create-article/create-article.component';
import { CreateInvoiceComponent } from './pages/create-invoice/create-invoice.component';
import { CreatePartnerComponent } from './pages/create-partner/create-partner.component';
import { CreateUserComponent } from './pages/create-user/create-user.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DuplicateInvoiceComponent } from './pages/duplicate-invoice/duplicate-invoice.component';
import { EmailVerificationFailComponent } from './pages/email-verification-fail/email-verification-fail.component';
import { EmailVerificationSuccessComponent } from './pages/email-verification-success/email-verification-success.component';
import { EmailVerificationComponent } from './pages/email-verification/email-verification.component';
import { ForgottenPasswordSuccessComponent } from './pages/forgotten-password-success/forgotten-password-success.component';
import { ForgottenPasswordComponent } from './pages/forgotten-password/forgotten-password.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { LoginComponent } from './pages/login/login.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { PaymentsComponent } from './pages/payments/payments.component';
import { UpdateArticleComponent } from './pages/update-article/update-article.component';
import { UpdateInvoiceComponent } from './pages/update-invoice/update-invoice.component';
import { UpdatePartnerComponent } from './pages/update-partner/update-partner.component';
import { UpdateUserComponent } from './pages/update-user/update-user.component';
import { UsersComponent } from './pages/users/users.component';
import { AuthenticationService } from './services/auth/authentication.service';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'email/verification/success', component: EmailVerificationSuccessComponent},
    { path: 'email/verification/fail', component: EmailVerificationFailComponent},
    { path: 'email/verification/:url', component: EmailVerificationComponent},
    { path: 'forgotten-password', component: ForgottenPasswordComponent},
    { path: 'forgotten-password/success', component: ForgottenPasswordSuccessComponent},
    { path: 'dashboard', component: DashboardComponent, canActivate: [() => inject(AuthenticationService).isVerificationCodeAuthenticated()],
        children: [
            {path: '', component: InvoicesComponent},
            {path: 'users', component: UsersComponent},
            {path: 'users/create', component: CreateUserComponent},
            {path: 'users/update', component: UpdateUserComponent},
            {path: 'invoices', component: InvoicesComponent},
            {path: 'invoices/create', component: CreateInvoiceComponent},
            {path: 'invoices/update', component: UpdateInvoiceComponent},
            {path: 'invoices/duplicate', component: DuplicateInvoiceComponent},
            {path: 'payments/:invoiceId', component: PaymentsComponent},
            {path: 'articles', component: ArticlesComponent},
            {path: 'articles/create', component: CreateArticleComponent},
            {path: 'articles/update', component: UpdateArticleComponent},
            {path: 'partners', component: PartnersComponent},
            {path: 'partners/create', component: CreatePartnerComponent},
            {path: 'partners/update', component: UpdatePartnerComponent},
            {path: '**', redirectTo: '', pathMatch: 'full'}
        ]
     },
    {path: '**', redirectTo: 'login', pathMatch: 'full'}
];
